<mat-card>
  <mat-card-header>
    <mat-card-title>Adicionar contato</mat-card-title>
  </mat-card-header>
  <div class="row m-0">
    <div class="col-md-12 mb-2 p-0 flex-column">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>
          Contato
        </mat-label>
        <input matInput type="text" [formControl]="form.get('contato')" />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('contato').touched && form.get('contato').hasError('required')">
        O contato é requerido.
      </small>
      <small class="p-error" *ngIf="form.get('contato').touched && form.get('contato').hasError('isEmptyValue')">
        Valor inválido: remova os espaços em branco!
      </small>
      <small class="p-error" *ngIf="form.get('contato').touched && form.get('contato').hasError('maxlength')">
        Contato aceita no máximo 100 caracteres
      </small>
    </div>
    <chip-input
      class="col-md-12 p-0"
      style="width: 100% !important;"
      id="tag-catalogo"
      placeholder="Tags do contato"
      [tagContato]="true"
      [initialValue]="tagsBck"
      (onChange)="onChangeTag($event)"
    ></chip-input>
  </div>
  <mat-card-actions>
    <div
      class="w-100 mt-2 d-flex justify-content-between justify-content-start align-items-center"
    >
      <button
        type="button"
        class="mr-md-4"
        mat-stroked-button
        id="cancel-contato-btn"
        (click)="cancelar()"
      >
        Cancelar
      </button>
      <button
        id="save-contato-btn"
        mat-raised-button
        type="submit"
        color="primary"
        (click)="salvar()"
        [disabled]="!form.valid"
      >
        Salvar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
